import { validateTickers } from '../../../main/modules/portfolio/services/api'
import { createAlertRequest } from '../../../main/services/api'
import { CreateAlertEntry, FormErrors } from './types'

export async function validateState(state: CreateAlertEntry) {
  const formErrors: FormErrors = {}

  if (state.ticker !== undefined && state.ticker.trim().length === 0) {
    formErrors.ticker = true
  } else if (state.ticker !== undefined) {
    const validatedTickers = await validateTickers([state.ticker.toUpperCase()])
    formErrors.ticker = validatedTickers[0] !== true
  }

  if (state.priceAbove !== '' && Number(state.priceAbove) <= 0) {
    formErrors.priceAbove = true
  }

  if (state.priceBelow !== '' && Number(state.priceBelow) <= 0) {
    formErrors.priceBelow = true
  }

  const eventTriggers = { ...state, ticker: undefined }
  delete eventTriggers.ticker
  formErrors.isEmpty = Object.values(eventTriggers).every((trigger) => trigger !== 0 && !trigger)

  return { isValid: !Object.values(formErrors).some(Boolean), errors: formErrors }
}

export async function submit(alert: CreateAlertEntry): Promise<{ isSuccess: boolean; message?: string }> {
  try {
    await createAlertRequest(alert)
    return { isSuccess: true }
  } catch (error) {
    const result = {
      isSuccess: false,
      message: 'There’s been an error creating the alert, make sure you’re connected to the Internet and try again.',
    }
    if (!!error && typeof error === 'object' && 'body' in error) {
      const apiError = error as { body: string }
      result.message = apiError.body
    }

    return result
  }
}
